import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { HighlightedOptionProps } from "./types";

const HighlightedOption = ({ text, query }: HighlightedOptionProps) => {
    const { blue700 } = colors;

    const queryTrimmed = query.trim();

    if (!queryTrimmed) return <>{text}</>;

    const i = text.toLowerCase().indexOf(queryTrimmed.toLowerCase());

    if (i === -1) return <>{text}</>;

    return (
        <>
            {text.slice(0, i)}

            <strong css={css({ fontWeight: 600, color: blue700 })}>
                {text.slice(i, i + queryTrimmed.length)}
            </strong>

            <HighlightedOption
                text={text.slice(i + queryTrimmed.length)}
                query={queryTrimmed}
            />
        </>
    );
};

export default HighlightedOption;
